// DEPENDENCIES
import React from 'react';
import '../../node_modules/react-image-gallery/styles/css/image-gallery.css';
// COMPONENTS
import Modal from 'react-bootstrap/Modal';
import ImageGallery from 'react-image-gallery';
// ICONS
import { BsTagFill, BsPlayFill, BsImage } from 'react-icons/bs';
import { FiTool, FiPlay } from 'react-icons/fi';
import { RiChat1Line } from 'react-icons/ri';
import { HiOutlineMail } from 'react-icons/hi';
import { FaInfo } from 'react-icons/fa';
import { IoIosImages } from 'react-icons/io';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';
import ContentHeader from './ContentHeader';
import ContentBlock from './ContentBlock';
import Image from './Image';
import FileUploadBlock from './FileUploadBlock';
// SERVICES AND HELPERS
import constants from '../constants/constants';
import { HelpOutlineRounded } from '@material-ui/icons';
import * as Helper from '../helpers/helper';

const ContentModal = (props) => {

    return (
        <>
            <Modal
                {...props}
                show={props.show ? props.show : false}
                onHide={props.onHide ? props.onHide : () => { }}
            >
                <CustomBlock className="content-container--card-style content mt-0">
                    <ContentHeader
                        title={props.contentHeader}
                        subtitle={props.subtitle}
                        primaryButtonText={props.primaryButtonText}
                        headerSize="mdlg"
                        iconLeftClassName="lighter-blue--bg"
                        iconLeft={
                            <BsTagFill className="info--clr" />
                        }
                    />

                    <CustomBlock className="content-block">
                        <p>
                            {props.contentDescription ? props.contentDescription : "No Description Available"}
                        </p>
                    </CustomBlock>
                </CustomBlock>

                {
                    props.additionalDetails &&
                    <CustomBlock className="content-container--card-style content mt-0 border-top square-border-top">
                        <ContentHeader
                            title={props.additionalDetailsHeader}
                            headerSize="mdlg"
                            iconLeftClassName="lighter-green--bg"
                            iconLeft={
                                <FaInfo className="success--clr" />
                            }
                        />

                        <CustomBlock className="content-block">
                            <p>
                                {props.additionalDetails}
                            </p>
                        </CustomBlock>
                    </CustomBlock>
                }

                {
                    props.primaryVideoUrl &&
                    <CustomBlock className="content-container--card-style content mt-0 border-top square-border-top">
                        <ContentHeader
                            title={props.primaryVideoHeader}
                            headerSize="mdlg"
                            iconLeftClassName="lighter-red--bg"
                            iconLeft={
                                <BsPlayFill className="danger--clr" size={35} style={{ marginLeft: 3 }} />
                            }
                        />

                        <ContentBlock>
                            {/* {
                            salesTool.videoPath &&
                                <FileUploadBlock
                                    videoUrl={`${constants.STORAGE_URL}${salesTool.videoPath}`}
                                />
                        } */}
                            <FileUploadBlock
                                videoUrl={props.primaryVideoUrl ? (props.primaryVideoUrl.includes('http') ? props.primaryVideoUrl : `${constants.STORAGE_URL}${props.primaryVideoUrl}`) : null}
                            //videoPath ? (videoPath.includes('http') ? videoPath : `${constants.STORAGE_URL}${videoPath}`) : null
                            />
                        </ContentBlock>
                    </CustomBlock>
                }

                {
                    props.secondaryVideoUrl &&
                    <CustomBlock className="content-container--card-style content mt-0 border-top square-border-top">
                        <ContentHeader
                            title={props.secondaryVideoHeader}
                            headerSize="mdlg"
                            iconLeftClassName="lighter-blue--bg"
                            iconLeft={
                                <BsPlayFill className="darker-blue--clr" size={35} style={{ marginLeft: 3 }} />
                            }
                        />

                        <ContentBlock>
                            {/* {
                            salesTool.videoPath &&
                                <FileUploadBlock
                                    videoUrl={`${constants.STORAGE_URL}${salesTool.videoPath}`}
                                />
                        } */}
                            <FileUploadBlock
                                videoUrl={props.secondaryVideoUrl ? (props.secondaryVideoUrl.includes('http') ? props.secondaryVideoUrl : `${constants.STORAGE_URL}${props.secondaryVideoUrl}`) : null}
                            />
                        </ContentBlock>
                    </CustomBlock>
                }

                {
                    props.primaryImageUrl &&
                    <CustomBlock className="content-container--card-style content mt-0 border-top square-border-top">
                        <ContentHeader
                            title={props.primaryImageHeader}
                            headerSize="mdlg"
                            iconLeftClassName="lighter-green--bg"
                            iconLeft={
                                <BsImage className="success--clr" />
                            }
                        />

                        <CustomBlock className="content-block">
                            <Image
                                source={`${constants.API_URL}Attachments/${props.primaryImageUrl}`}
                                roundCorners
                            />
                        </CustomBlock>
                    </CustomBlock>
                }

                {
                    props.secondaryImageUrl &&
                    <CustomBlock className="content-container--card-style content mt-0 border-top square-border-top">
                        <ContentHeader
                            title={props.secondaryImageHeader}
                            headerSize="mdlg"
                            iconLeftClassName="lighter-blue--bg"
                            iconLeft={
                                <BsImage className="info--clr" />
                            }
                        />

                        <CustomBlock className="content-block">
                            <Image
                                source={`${constants.API_URL}Attachments/${props.secondaryImageUrl}`}
                                roundCorners
                            />
                        </CustomBlock>
                    </CustomBlock>
                }
                {
                    props.multipleImageList != null &&
                    props.multipleImageList.length > 0 &&
                    <CustomBlock className="content-container--card-style content mt-0 border-top square-border-top">
                        <ContentHeader
                            title={props.multipleImageListHeader}
                            headerSize="mdlg"
                            iconLeftClassName="lighter-blue--bg"
                            iconLeft={
                                <IoIosImages className="info--clr" />
                            }
                        />

                        <CustomBlock className="content-block">
                            <ImageGallery
                                items={props.multipleImageList.map(x => {
                                    return { original: `${constants.API_URL}Attachments/${x}`, thumbnail: `${constants.API_URL}Attachments/${x}` }
                                })}
                            />
                        </CustomBlock>
                    </CustomBlock>
                }
            </Modal>

        </>
    );
}

export default ContentModal;